const useAllHomeStyles = async(): Promise<object> => {
    const { data } = await useAsyncData('', async () => {
        const homeStyles = await queryCollection("homeStyles").all()
        
        // Sort by date descending
        return homeStyles.sort((a: any, b: any) => {
            return new Date(b.date).getTime() - new Date(a.date).getTime()
        })
    });

    return data;
}

const useHomeStylesByType = async(type: string): Promise<object> => {
    const { data } = await useAsyncData(`homeStyles-${type}`, async () => {
        const homeStyles = await queryCollection("homeStyles").all()
        
        // Filter by type and sort by date descending
        return homeStyles
            .filter((style: any) => style.type && style.type.includes(type))
            .sort((a: any, b: any) => {
                return new Date(b.date).getTime() - new Date(a.date).getTime()
            })
    });

    return data;
}


export {
    useAllHomeStyles,
    useHomeStylesByType
};